import { useEffect, useState } from 'react';
import { axiosInstance } from 'setup/axiosInstance';
import { DictionaryIrregularVerb } from 'app/types';

interface State {
  loading: boolean;
  verbs: DictionaryIrregularVerb[];
  error: string | null;
}

/**
 * Single-source fetch of all irregular verbs WITH the current user's vocabulary
 * state merged in (isLearned / isActiveSpeech). All cards on the browse page
 * aggregate from this list — no per-mode endpoint fetches needed.
 */
export function useAllVerbs(): State {
  const [state, setState] = useState<State>({ loading: true, verbs: [], error: null });

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    axiosInstance
      .get<DictionaryIrregularVerb[]>('/wordset/irregular-verb/all')
      .then((res) => {
        if (cancelled) return;
        setState({ loading: false, verbs: res.data, error: null });
      })
      .catch((e) => {
        if (cancelled) return;
        setState({ loading: false, verbs: [], error: e?.message ?? 'fetch failed' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
